import { Component, OnInit, ElementRef } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import * as UserDataConfig from '../../config/user-data.config';
import { Observable, Subscription } from 'rxjs';
import { YourDependantDetails } from 'src/app/model/ngrx/your-dependant-details.model';
import { DependantDetails } from 'src/app/model/ngrx';
import { AppState } from 'src/app/store/state/app.state';
import { Router, ActivatedRoute } from '@angular/router';
import { CmsService } from 'src/app/core/cms/service.service';
import { AnalyticsService, ApplicationDataCaptureService, AnnuitantDetailService, FormValidationsService, SERVICE_END_POINT, UtilService, AuthService } from 'src/app/shared';
import { Store } from '@ngrx/store';
import * as yourDependantDetailsActions from '../../../../store/actions/your-dependant-details.actions';
import { Tooltip } from 'src/app/model/tooltip';
import { ParentFormAndElmModel } from 'src/app/model/key-value-modal';
import { quoteLevelConstants } from '../../../../shared/constants/attribute-values.constants';
import { STORE_VAL } from 'src/app/shared/constants/store-val.constant';
import { AlertModal } from 'src/app/model/alert';

@Component({
  selector: 'app-your-dependant-details',
  templateUrl: './your-dependant-details.component.html',
  styleUrls: ['./your-dependant-details.component.scss']
})
export class YourDependantDetailsComponent implements OnInit {
  yourDependantDetailForm: UntypedFormGroup;

  public afterApplyDetail = UserDataConfig.ElementsConfig;
  public titleConfig = this.afterApplyDetail.titleConfig;
  public forenameTextCodeConfig = this.afterApplyDetail.forenameTextConfig;
  public surnameTextCodeConfig = this.afterApplyDetail.surnameTextConfig;
  public middleNameTextCodeConfig = this.afterApplyDetail.middleNameTextConfig;
  public thirdNameTextCodeConfig = this.afterApplyDetail.thirdNameTextConfig;
  protected maritalStatusConfig = this.afterApplyDetail.maritalStatusConfig;
  public firstNameToolTipInfoCodeConfig = this.afterApplyDetail.firstNameToolTipInfoConfig;
  public dateOfBirthData: string;
  public tooltipModalConfig: AlertModal;
  public genderData: string;
  protected genderCode: string;
  public relationShipData: string;
  protected relationShipCode: string;

  yourDependantDetailsStore: Observable<YourDependantDetails[]>;
  yourDependantDetails: YourDependantDetails;
  yourDependantDetailsStoreSubscription: Subscription;
  subscripSaveProgress: Subscription;
  subscriptn: Subscription;
  subscripLogout: Subscription;

  contentData;
  storeFlag: boolean = false;
  dependantDetailsStore: Observable<DependantDetails[]>;
  protected dependantQuote: DependantDetails;
  public otherTitleList: any;
  enableOtherTitle: boolean = false;
  public otherTitle = [];
  public array1 = [];
  public yourDependantConfig: Tooltip;
  private responseApplicationData: any[];
  private responseApplicationDataStore: Observable<any[]>;
  maritalStatusOptions;
  CMSData;
  resultQuote: any;
  tooltipModal;
  displayTooltipAlert;
  constructor(private router: Router,
    private fb: UntypedFormBuilder,
    private cmsService: CmsService,
    private activatedRoute: ActivatedRoute,
    private applicationDatacaptureService: ApplicationDataCaptureService,
    private annuitantService: AnnuitantDetailService,
    private analyticsService: AnalyticsService,
    public el: ElementRef,
    private store: Store<AppState>,
    private utilService: UtilService, private authService: AuthService) {
    this.contentData = this.activatedRoute.snapshot.data.contentData.yourDependantDetails;
    this.yourDependantDetailsStore = store.select(STORE_VAL.your_dependant_details);
    this.responseApplicationDataStore = this.store.select(STORE_VAL.application_data_response);
    this.tooltipModal = this.activatedRoute.snapshot.data.contentData.tooltipModalConfig;
    this.yourDependantDetailsStoreSubscription = this.yourDependantDetailsStore.subscribe(val => {
      if (val) {
        this.yourDependantDetails = val[0];
        //console.log(this.yourDependantDetails);
      }
    });
    this.responseApplicationDataStore.subscribe((val) => {
      if (val.length > 0) {
        this.responseApplicationData = val[0];
      }
    });
    this.dependantDetailsStore = store.select(STORE_VAL.dependant_details);
    this.dependantDetailsStore.subscribe(res => {
      if (res.length > 0) {
        this.dependantQuote = res[0];
        //console.log(this.dependantQuote);
      }
    });
    store.select(STORE_VAL.quote_result).subscribe(res => {
      if (res.length > 0) {
        this.resultQuote = res[0];
      }
    });
  }

  ngOnInit() {
    this.GetCMSDataServiceMapper();
    this.storeData();
    this.maritalStatusView(); // added this as part of Defect#2751 - DTC-295 new requirement
    this.tooltipModalConfig = this.activatedRoute.snapshot.data.contentData.tooltipModalConfig;
    if (this.yourDependantDetails && !this.checkProperties(this.yourDependantDetails)) {
      // Fix Title from HO
      if (this.yourDependantDetails.title &&
        this.yourDependantDetails.title !== '' &&
        this.yourDependantDetails.title !== 'Other' &&
        this.yourDependantDetails.title !== 'Mr' &&
        this.yourDependantDetails.title !== 'Miss' &&
        this.yourDependantDetails.title !== 'Mrs' &&
        this.yourDependantDetails.title !== 'Ms' &&
        this.yourDependantDetails.title !== 'Mx' &&
        this.yourDependantDetails.title !== 'Doctor') { // Title others
        this.yourDependantDetails['otherTitle'] = this.yourDependantDetails.title;
        this.yourDependantDetails.title = 'Other';
      }
      if( this.titleConfig &&  this.titleConfig.options.length > 0 && this.yourDependantDetails.title === 'Other') {
        if(this.titleConfig.options.filter(val => val['value'] == this.yourDependantDetails.otherTitle).length == 1) {
          this.yourDependantDetails.title = this.yourDependantDetails.otherTitle;
          this.yourDependantDetails.otherTitle = '';
        }
      }
      this.enableOtherTitle = this.yourDependantDetails.title === 'Other' ? true : false;
      this.getOtherTitle();
      this.setApplyDependantForm();
    } else if (this.responseApplicationData && !this.checkProperties(this.responseApplicationData)) {
      this.setDependantFormUsingQuoteValues();
    } else {
      this.userFormData();
    }
    // tslint:disable-next-line:max-line-length
    this.subscripSaveProgress = this.applicationDatacaptureService.subsVar = this.applicationDatacaptureService.invokeSaveFunction.subscribe(() => {
      this.saveProgress();
    });
    // tslint:disable-next-line:max-line-length
    this.subscripLogout = this.applicationDatacaptureService.subsVar = this.applicationDatacaptureService.invokeLogoutFunction.subscribe(() => {
      this.saveAfterLogout();
    });
    const obj = new ParentFormAndElmModel(this.yourDependantDetailForm, this.el, null, null);
    this.utilService.setParentFormToValidate(obj);
  }
  userFormData = () => {
    this.yourDependantDetailForm = this.fb.group({
      title: [null, Validators.required],
      otherTitle: [null],
      forename: [null, [Validators.required, Validators.maxLength(35)]],
      surname: [null, [Validators.required, Validators.maxLength(35)]],
      middleName: [null, [Validators.maxLength(35)]],
      thirdName: [null, [Validators.maxLength(35)]],
      dateOfBirth: [this.dateOfBirthData],
      gender: [this.genderCode],
      maritalStatus: [null, Validators.required],
      relationShip: [this.relationShipCode]
    });
  }
  setApplyDependantForm = () => {
    this.yourDependantDetailForm = this.fb.group({
      title: [this.yourDependantDetails?.title, Validators.required],
      otherTitle: [this.yourDependantDetails.otherTitle],
      // tslint:disable-next-line:max-line-length
      forename: [this.yourDependantDetails.forename, [Validators.required, Validators.maxLength(35)]],
      // tslint:disable-next-line:max-line-length
      surname: [this.yourDependantDetails.surname, [Validators.required, Validators.maxLength(35)]],
      // tslint:disable-next-line:max-line-length
      middleName: [this.yourDependantDetails.middleName, [Validators.maxLength(35)]],
      // tslint:disable-next-line:max-line-length
      thirdName: [this.yourDependantDetails.thirdName, [Validators.maxLength(35)]],
      dateOfBirth: [this.yourDependantDetails.dateOfBirth],
      gender: [this.yourDependantDetails.gender],
      maritalStatus: [this.yourDependantDetails.maritalStatus, Validators.required],
      relationShip: [this.yourDependantDetails.relationShip]
    });
  }
  setDependantFormUsingQuoteValues = () => {
    this.yourDependantDetailForm = this.fb.group({
      title: [this.responseApplicationData['secondLife'].title, Validators.required],
      otherTitle: [this.responseApplicationData['secondLife'].otherTitle],
      // tslint:disable-next-line:max-line-length
      forename: [this.responseApplicationData['secondLife'].forename, [Validators.required, Validators.maxLength(35)]],
      // tslint:disable-next-line:max-line-length
      surname: [this.responseApplicationData['secondLife'].surname, [Validators.required, Validators.maxLength(35)]],
      // tslint:disable-next-line:max-line-length
      middleName: [this.responseApplicationData['secondLife'].middleName, [Validators.maxLength(35)]],
      // tslint:disable-next-line:max-line-length
      thirdName: [this.responseApplicationData['secondLife'].thirdName, [Validators.maxLength(35)]],
      dateOfBirth: [this.dateOfBirthData],
      gender: [this.genderCode],
      maritalStatus: [this.responseApplicationData['secondLife'].maritalStatus, Validators.required],
      relationShip: [this.relationShipCode]
    });
  }
  saveProgress() {
    // Onclick of Save Progress button logic
    this.saveFormValues();
    this.subscriptn = this.applicationDatacaptureService.postApplicationDataCapture(false).subscribe();
  }
  saveAfterLogout() {
    // Onclick of Logout button logic
    this.saveFormValues();
    this.subscriptn = this.applicationDatacaptureService.postApplicationDataCapture(false).subscribe(res => {
      this.authService.logout();
    });
  }
  // tslint:disable-next-line:use-life-cycle-interface
  ngOnDestroy() {
    // OnDestroy unsubscribing the subcriptions
    if (this.subscriptn) {
      this.subscriptn.unsubscribe();
    }
    if (this.subscripSaveProgress) {
      this.subscripSaveProgress.unsubscribe();
    }
    if (this.subscripLogout) {
      this.subscripLogout.unsubscribe();
    }
    if (this.yourDependantDetailsStoreSubscription) {
      this.yourDependantDetailsStoreSubscription.unsubscribe();
    }
    this.utilService.setParentFormToValidate(null);
  }

  onBackClick() {
    // OnBackClick this method invokes
    this.saveFormValues();
    // Do routing here...!!!
    // this.router.navigate(['/apply/your-personal-details']);
  }

  saveFormValues() {
    // To save all fields values into the store
    this.store.dispatch(new yourDependantDetailsActions.RemoveYourDependantDetails(0));
    this.store.dispatch(new yourDependantDetailsActions.AddYourDependantDetails({
      title: this.yourDependantDetailForm.value.title ? this.yourDependantDetailForm.value.title : null,
      otherTitle: this.yourDependantDetailForm.value.otherTitle ? this.yourDependantDetailForm.value.otherTitle : null,
      forename: this.yourDependantDetailForm.value.forename ? this.yourDependantDetailForm.value.forename : null,
      surname: this.yourDependantDetailForm.value.surname ? this.yourDependantDetailForm.value.surname : null,
      middleName: this.yourDependantDetailForm.value.middleName,
      thirdName: this.yourDependantDetailForm.value.thirdName,
      dateOfBirth: this.dateOfBirthData,
      gender: this.genderCode,
      maritalStatus: this.yourDependantDetailForm.value.maritalStatus,
      relationShip: this.relationShipCode
    }));
    //console.log('Stored->', this.yourDependantDetails);
  }

  gotoNext() {
    // Triggers on click on Next button
    if (this.yourDependantDetailForm.valid) {
      this.saveFormValues();
      this.applicationDatacaptureService.postApplicationDataCapture(true).subscribe(res => {
        //console.log('Response from backend', res);
        // Do routing here...!!!
        if (this.resultQuote['isGMP'] === quoteLevelConstants.radioToggleYesNo.yes) {
          this.router.navigate(['/apply/your-pension-savings']);
        } else {
          this.router.navigate(['/apply/your-dependants-doctors-details']);
        }
      });
      //console.log('Valid', this.yourDependantDetailForm);
    } else {
      //console.log('Not Valid', this.yourDependantDetailForm);
      FormValidationsService.validateAllFormFields(this.yourDependantDetailForm, this.analyticsService);
      setTimeout(() => {
        this.scrollInvalidForm();
      }, 0);
    }
  }

  scrollInvalidForm() {
    // To scroll the page and to show the first occurance of form-field error
    const invalidElements = this.el.nativeElement.querySelectorAll('.form-validation-error');
    if (invalidElements.length > 0) {
      invalidElements[0].scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
    }
  }

  dateFormat = (dateValue: string) => {
    return dateValue.indexOf('/') > -1 ? (dateValue.split('/').join(' / ')) : dateValue;
  }

  storeData() {
    if (this.yourDependantDetails) {
      // tslint:disable-next-line:max-line-length
      this.dateOfBirthData = this.yourDependantDetails && this.yourDependantDetails.dateOfBirth ? this.yourDependantDetails.dateOfBirth : '';
      // tslint:disable-next-line:max-line-length
      this.genderCode = this.responseApplicationData && this.yourDependantDetails.gender ? this.yourDependantDetails.gender : '';
      this.genderData = this.responseApplicationData && this.yourDependantDetails.gender ? (this.afterApplyDetail.genderConfig.options.filter(item => item.code === this.yourDependantDetails.gender))[0].value : 'Not provided';
      // tslint:disable-next-line:max-line-length
      this.relationShipCode = this.responseApplicationData && this.yourDependantDetails.relationShip ? this.yourDependantDetails.relationShip : '';

      this.relationShipData = this.responseApplicationData && this.yourDependantDetails.relationShip ? (this.afterApplyDetail.relationshipConfig.options.filter(item => item.code === this.yourDependantDetails.relationShip))[0].value : 'Not provided';
      // this.relationShipData = this.responseApplicationData && this.yourDependantDetails.relationShip ? this.yourDependantDetails.relationShip : '';

    } else {
      // tslint:disable-next-line:max-line-length
      this.dateOfBirthData = this.responseApplicationData && this.responseApplicationData['secondLife'].dateOfBirth ? this.dateFormat(this.responseApplicationData['secondLife'].dateOfBirth) : 'Not provided';
      // tslint:disable-next-line:max-line-length
      this.genderData = this.responseApplicationData && this.responseApplicationData['secondLife'].gender ? (this.afterApplyDetail.genderConfig.options.filter(item => item.code === this.responseApplicationData['secondLife'].gender))[0].value : 'Not provided';
      this.genderCode = this.responseApplicationData && this.responseApplicationData['secondLife'].gender ? this.responseApplicationData['secondLife'].gender : '';
      // tslint:disable-next-line:max-line-length
      this.relationShipCode = this.responseApplicationData && this.responseApplicationData['secondLife'].relationshipToCustomer ? this.responseApplicationData['secondLife'].relationshipToCustomer : '';
      this.relationShipData = this.responseApplicationData && this.responseApplicationData['secondLife'].relationshipToCustomer ? (this.afterApplyDetail.relationshipConfig.options.filter(item => item.code === this.responseApplicationData['secondLife'].relationshipToCustomer))[0].value : 'Not provided';

    }
  }
  getOtherTitle() {
    this.annuitantService.getOtherTitle().subscribe(data => {
      this.otherTitleList = data;
    });
    this.otherTitle = this.array1;
  }
  detectChange() {
    //const otherTitleControlname = this.registrationDetailForm.get('otherTitle');
    const othTitle = this.yourDependantDetailForm.get('otherTitle');
    if (this.titleConfig.defaultValue === 'Other') {
      this.enableOtherTitle = true;
      othTitle.setValidators(Validators.required);
      this.getOtherTitle();
    } else {
      this.yourDependantDetailForm.controls['otherTitle'].setValue(null);
      this.enableOtherTitle = false;
      othTitle.setValidators(null);
      // this.otherTitle=null;
    }
    this.triggerotherTitleValidation();

  }
  triggerotherTitleValidation() {
    this.yourDependantDetailForm.updateValueAndValidity();
  }
  checkProperties = (obj) => {
    for (const key in obj) {
      if (obj[key] !== null && obj[key] !== '') {
        return false;
      }
    }
    return true;
  }
  maritalStatusView = () => {
    this.maritalStatusOptions = JSON.parse(JSON.stringify(this.maritalStatusConfig));
    if (this.maritalStatusConfig && this.relationShipData === 'Spouse') {
      this.maritalStatusOptions.options = this.maritalStatusConfig.options.filter(item => item.code === 'M');
    } else if (this.maritalStatusConfig && this.relationShipData === 'Registered civil partner') {
      this.maritalStatusOptions.options = this.maritalStatusConfig.options.filter(item => item.code === 'CP');
    } else if (this.maritalStatusConfig && this.relationShipData === 'Financial dependant') {
      this.maritalStatusOptions.options = this.maritalStatusConfig.options;
    }
  }

  /** Code block for CMS */
  GetCMSDataServiceMapper() {

    const URL = SERVICE_END_POINT.higherEnvironment.CMS_YourDependantDetailsApply;
    this.utilService.getCMSData(URL).subscribe(res => {
      this.CMSData = res;
      if (this.CMSData) {
        /** In the line below we are over-writing the contentData object values with CMSData object values */
        this.contentData.header = this.CMSData.string_ApplyYourDependantDetailsTitle;
        this.contentData.introduction = this.CMSData.string_ApplyYourDependantDetailsSubTitle1;
        this.contentData.infoText = this.resultQuote['isGMP'] === quoteLevelConstants.radioToggleYesNo.yes
          ? this.CMSData.string_ApplyYourDependantDetailsSubTitleGMP : this.CMSData.string_ApplyYourDependantDetailsSubTitle2;
        this.contentData.noteStatement = this.CMSData.string_ApplyDependantDetailsInformationBoxWording;
        this.yourDependantConfig = new Tooltip(this.contentData.infoText, '', false);
      }
    });
  }

  displayTooltipMessage(el) {
    let config;

    switch(el) {
      case "depNoteConfig":
        config = this.yourDependantConfig;
        break;
      case "firstnameConfig":
        config = this.firstNameToolTipInfoCodeConfig;
        break;
    }
    this.tooltipModal.content = config.content;
    this.displayTooltipAlert = true;
  }

  closeTooltipModal() {
    this.displayTooltipAlert = false;
  }

  alertTooltipPrimaryBtnClick() {
    this.displayTooltipAlert = false;
  }
}

